import {IRouteDefinition, TRouteId} from "../../index.d";
import {getHash, getRouteDefinition, getRouteLabel, isRoutePermissionOkay} from "../../constants/RouteDefinitions";
import {nsSitemap} from "@component/sitemap/nsSitemap";
import {global} from "../../appContext";
import {nsRoute} from "../../util/route";
import sitemapHtml from './sitemap.html?raw';

export const template = sitemapHtml

export class viewModel {
    private getRouteLabel: any = getRouteLabel;
    private getHash: any = getHash;
    private isRouteDefinitionOkay(routeId: TRouteId): boolean {
        const def = getRouteDefinition(routeId)
        if (!def || !isRoutePermissionOkay(def)) {
            return false
        }
        const org = global.login.selectedOrganization();
        if (!org || !nsRoute.isRouteLicenseOkay(def, org)) {
            return false
        }
        return true
    };

    private SitemapTree = nsSitemap.SitemapTree

    private getIcon(routeId: TRouteId): IRouteDefinition['icon'] {
        const routeDef = getRouteDefinition(routeId)
        return routeDef?.icon ?? undefined
    }
}